export * from './components/super-tab';
export * from './components/super-tabs';
export * from './providers/super-tabs-controller';
export * from './super-tabs.module';



// WEBPACK FOOTER //
// ./src/components/ionic2-super-tabs/src/index.ts